import {TextField, Typography} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import { AddressAction } from '../../../action/address.action';
import { AddressActor } from '../../../actor/address.actor';
import { Village, VillageData } from '../../../service/response/village.response';
import { AddressStore } from '../../../store/address.store';
import { useObservable } from '../../../useSubscriber';
import {useStyles} from './ui.style';
import { useTranslation } from "react-i18next"
export const VillagePickerComponent = (props: any) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const [villageList, villageListError] = useObservable(AddressStore.getVillageList(), AddressStore.getVillageListObservable())
    const [delarDto] = useObservable((props.Store).getDelarDto(), (props.Store).getDelarDtoObservable())
    
    const [loading, setLoading] = useState(false)
    const [villageData, setVillageData] = useState<Array<VillageData>>([])
    
    useEffect(() => {
        setLoading(true)
        AddressActor({ "type": AddressAction.GET_VILLAGE_LIST }, {"subDistrictCode": props.subDistrictCode})
    }, [])

    useEffect(() => {
        if (!villageListError.error && villageList) {
            var newVillages: Array<VillageData> = Object.keys(villageList).map(function(index: any){
                let village = (villageList as VillageData[])[index]
                return village;
            });
            setVillageData(newVillages)
        }
        setLoading(false)
    }, [villageList])

    return (
        !loading && <Autocomplete
            id="combo-box-demo"
            options={villageData}
            defaultValue={delarDto?.shopAddress?.geoAddress?.village}
            getOptionLabel={(option: VillageData) => option.name}
            onChange={(event, village) => props.setVillage(village)}
            fullWidth={true}
            loading={villageData.length > 0 ? true : false}
            classes={{ input: classes.input  }}
            style={{marginTop:8,}}
            renderInput={(params: any) => <TextField {...params}
            defaultValue={delarDto?.shopAddress?.geoAddress?.village?.name}
            // classes = {{
            //     root: delarDtoError?.village.error?classes.TextFieldRoot: classes.noStyle,
            // }}
                label={<Typography variant="body2" style ={{fontSize: 12}} color="textSecondary">{t("common_type_village")}</Typography>} variant="outlined" />}
        />
    );
}